import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Header from "./components/Header";
import Instructions from "./components/Instructions";
import "./App.css";
import WhatsAppButton from "./components/botonwts"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div className="app-container">
      <WhatsAppButton />
      <Header />
      <Instructions />
      <App />
    </div>
    
  </React.StrictMode>
);